function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * 注册全局Interceptors
 */
export function injectGlobalInterceptors(axios) {
  var _globalAxiosIntercept, _globalAxiosIntercept2;
  if (!window.GlobalInterceptors$$) {
    window.GlobalInterceptors$$ = {};
  }
  if (!window.GlobalInterceptors$$.request) {
    window.GlobalInterceptors$$.request = [];
  }
  if (!window.GlobalInterceptors$$.response) {
    window.GlobalInterceptors$$.response = [];
  }
  var globalAxiosInterceptors = window.GlobalInterceptors$$;
  if (!globalAxiosInterceptors) {
    return;
  }
  var register = function register(type, interceptor) {
    if (typeof interceptor === 'function') {
      axios.interceptors[type].use(interceptor);
    } else if (_typeof(interceptor) === 'object') {
      var onFulfilled = interceptor.onFulfilled,
        onRejected = interceptor.onRejected;
      axios.interceptors[type].use(onFulfilled, onRejected);
    }
  };
  (_globalAxiosIntercept = globalAxiosInterceptors.request) === null || _globalAxiosIntercept === void 0 || _globalAxiosIntercept.forEach(register.bind(null, 'request'));
  (_globalAxiosIntercept2 = globalAxiosInterceptors.response) === null || _globalAxiosIntercept2 === void 0 || _globalAxiosIntercept2.forEach(register.bind(null, 'response'));
}